import CalendarEntry from 'owa-service/lib/contract/CalendarEntry';
import CalendarColor from 'owa-service/lib/contract/CalendarColor';
import {
    getDefaultColorSchemesOrderedByColorIndex,
    getColorSchemeForHexColor,
} from 'owa-calendar-color-resolver';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';

let nextAutomaticColor: number = 0;

/**
 * Returns the hex color string to use for displaying shared calendars based on the colors coming
 * from the server for that calendar. If undefined, consider as automatic.
 *
 * This can't just be pulled from the calendar color cache because the color cache only gets values when
 * the calendar is actually selected. The shared calendar list includes even unselected calendars, so need
 * to resolve them separately. Can rely on the shared functions though.
 */
export function getCalendarSharingHexColor(calendarEntry: CalendarEntry): string {
    let calColor = calendarEntry.CalendarColor;
    let newColor: string;
    const colorSchemes = getDefaultColorSchemesOrderedByColorIndex();

    if (calColor === CalendarColor.Auto) {
        // resolve as auto
        newColor = colorSchemes[nextAutomaticColor].calPrimary;
        nextAutomaticColor++;

        if (nextAutomaticColor >= colorSchemes.length) {
            nextAutomaticColor = 0;
        }
    } else {
        // always default to using hex color string if not set to auto rather than CalendarColor
        newColor = calendarEntry.HexColorString;
    }

    return newColor;
}

/**
 * Generates the color scheme for the given calendar entry, specific to the sharing case
 * @param calendarEntry the calendar entry
 */
export function getCalendarSharingHexColorScheme(calendarEntry: CalendarEntry): ColorScheme {
    let calPrimary = getCalendarSharingHexColor(calendarEntry);
    return getColorSchemeForHexColor(calPrimary);
}
